export const TENANT_ALERT_REPORT_STATUS_REQUESTED = 'Requested';
export const TENANT_ALERT_REPORT_STATUS_GENERATED = 'Generated';

export const TENANT_ALERT_APPLICATION_STATUS_PROCESSING = 'Processing';
export const TENANT_ALERT_APPLICATION_STATUS_COMPLETED = 'Completed';
export const TENANT_ALERT_APPLICATION_STATUS_ERROR = 'ERROR';

export const TENANT_ALERT_SERVICE_CREDIT_REPORT = 18;
export const TENANT_ALERT_SERVICE_CRIMINAL_SEARCH = 161;
export const TENANT_ALERT_SERVICE_PREVIOUS_ADDRESS_HISTORY = 166;
export const TENANT_ALERT_SERVICE_EVICTION_SEARCH = 162;
export const TENANT_ALERT_SERVICE_SEX_OFFENDER_SEARCH = 163;
export const TENANT_ALERT_SERVICE_TERRORIST_SEARCH = 165;
export const TENANT_ALERT_SERVICE_REPORT_COMPLETED = 'Completed';

export const TENANT_ALERT_EXPIRATION_IN_DAYS = 60;

export const TENANT_ALERT_SERVICE_LIST = [
  TENANT_ALERT_SERVICE_CREDIT_REPORT,
  TENANT_ALERT_SERVICE_CRIMINAL_SEARCH,
  TENANT_ALERT_SERVICE_EVICTION_SEARCH,
  TENANT_ALERT_SERVICE_SEX_OFFENDER_SEARCH,
  TENANT_ALERT_SERVICE_TERRORIST_SEARCH,
  TENANT_ALERT_SERVICE_PREVIOUS_ADDRESS_HISTORY,
];
